module.exports = __webpack_public_path__ + "img/品牌赛事_1@2x.5df27b7a.png";